import eventsService from '@/api/eventsService'
const state = {
    
  
}
const mutations = {
    
}
const actions = {
    // 获取大事记列表
    getEventsList({ commit }, params) {
        return new Promise((resolve, reject) => {
            eventsService.fetchEventsList(params)
                .then(res => {
                    const { data } = res
                    resolve(data)
                })
        })
    }
   
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/events.js